/**
 * This module provides methods for detecting device information like device type and platform.
 *
 * Device types include: Mobile Phone, Desktop, Tablet
 * Plaforms include: iOS, Android, Win10, MacOSX, ipadOS, Linux
 *
 * Methods
 *
 * init: runs on startup. If running in standalone mode, the ignoreMobileInstallMessage cookie is erased.
 * if not in standalone mode, check if messageResetcookie exist. If not, remove all the ignoreMessage cookies
 * and set the reset cookie. This will re-initiate the various messages users have previously dismissed.
 *
 * isRunningStandalone: determines if browser is running in standalone display-mode which indicates
 * the app is installed on the mobile device.
 *
 */
const deviceInfo = (function () {
    const _settings = {
        deviceInfo: document.getElementById("js-device-info"),
    };
    async function init() {
        const runInit = () => {
            if (typeof userMessages !== "undefined") {
                // Check if running as standalone app and delete cookie if yes
                if (isRunningStandalone()) {
                    userMessages.deleteMessageCookie("ignoreMobileInstallMessage");
                } else {
                    const resetCookies = document.cookie
                        .split("; ")
                        .find((row) => row.startsWith(`messageReset=`))
                        ?.split("=")[1];
                    if (!resetCookies) {
                        userMessages.setMessageCookie("messageReset", 1, 365);
                        userMessages.deleteMessageCookie("ignoreMobileInstallMessage");
                        userMessages.deleteMessageCookie("ignoreMobileInstallMessageNumDays");
                        userMessages.deleteMessageCookie("ignorePushMessage");
                        userMessages.deleteMessageCookie("ignorePushMessageNumDays");
                    }
                }
            } else {
                setTimeout(runInit, 1000);
            }
        };
        runInit();
    }
    function isRunningStandalone() {
        return window.matchMedia("(display-mode: standalone)").matches;
    }

    function getDeviceType() {
        if (_settings.deviceInfo) {
            return _settings.deviceInfo.getAttribute("data-device-type");
        } else {
            return null;
        }
    }
    function getDevicePlatform() {
        if (_settings.deviceInfo) {
            return _settings.deviceInfo.getAttribute("data-device-platform");
        } else {
            return null;
        }
    }

    return {
        init: init,
        getDeviceType: getDeviceType,
        getDevicePlatform: getDevicePlatform,
        isRunningStandalone: isRunningStandalone,
    };
})();

export { deviceInfo };
